import React from "react";
import "./Footer.css";
import shapeImg from '../../../assets/Home/shape-bg.png';

export default function footer() {
  return (
    <div className="footer-container">
      <div className="footer-parent">
        <img
          src={shapeImg}
          // src={require("../../../assets/Home/shape-bg.png").default}
          alt="you have problem with the image"
        />
      </div>
    </div>
  );
}
